import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { ColumnDefinitionDto, MemberDto, ProductSearchDto, ResultListDto } from "./dto";
import { InsurancePremiumRecipientDto, PolicyDto, ProductDto, PolicyScheduleUploadDto, ProductStatsWrapperDto, ScheduleUploadStatusDto } from "./dto-insurance";

@Injectable({
	providedIn: 'root'
})
export class HttpInsuranceProductService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/insurance/product', authService);
	}

	public get(id: number): Observable<ProductDto> {
		return super.doGet(true, `/${id}`);
	}
	public getWithStats(id: number): Observable<ProductStatsWrapperDto> {
		return super.doGet(true, `/${id}/with_stats`);
	}


	public getAll(pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<ProductDto>> {
		return super.doGet(true, `/?pageIndex=${pageIndex}&pageSize=${pageSize}`);
	}
	public getAllWithStats(): Observable<ProductStatsWrapperDto[]> {
		return super.doGet(true, `/all_with_stats`);
	}
	public create(payload: ProductDto): Observable<ProductDto> {
		return super.doPost(true, `/`, payload);
	}
	public update(id: number, payload: ProductDto): Observable<ProductDto> {
		return super.doPost(true, `/${id}`, payload);
	}

	public getPolicies(productId: number, pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<PolicyDto>> {
		return super.doGet(true, `/${productId}/policy?pageIndex=${pageIndex}&pageSize=${pageSize}`);
	}

	public getSchedules(productId: number, pageIndex: number = 1, pageSize: number = 1000): Observable<ResultListDto<PolicyScheduleUploadDto>> {
		return super.doGet(true, `/${productId}/schedule?pageIndex=${pageIndex}&pageSize=${pageSize}`);
	}
	public getSchedule(scheduleId: number): Observable<PolicyScheduleUploadDto> {
		return super.doGet(true, `/schedule/${scheduleId}`);
	}
	public createAndValidateSchedule(productId: number, bankDepositAmount: number, fileUuid: string): Observable<PolicyScheduleUploadDto> {
		console.log("Posting",bankDepositAmount);
		return super.doPost(true, `/${productId}/schedule/${fileUuid}/new`, bankDepositAmount);
	}
	public getPremiumRecipients(): Observable<InsurancePremiumRecipientDto[]> {
		return super.doGet(true, `/premium-recipients`);
	}
	public getOfferLineNames(): Observable<string[]> {
		return super.doGet(true, `/offer-line-names`);
	}


	public findProductsForMember(filters: ProductSearchDto): Observable<ResultListDto<ProductDto>> {
		return super.doPost(true, `/search/product_and_offer`, filters);
	}
	public getScheduleFormat(): Observable<ColumnDefinitionDto[]>{
		return super.doGet(true,`/schedule_format`);
	}

	public getScheduleUploadStats(id: number): Observable<ScheduleUploadStatusDto>{
		return super.doGet(true,`/schedule/${id}/status`);
	}
}
